import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./style.css";
export default function Loader() {
  return (
    <div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden"></span>
        </Spinner>
      </div>
    </div>
  );
}
